import { Button, Result } from 'antd';
import { useIntl } from 'react-intl';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getRequestErrorMessage } from '@/requestErrorConfig';
import { useAuthStore } from '@/stores/authStore';

export default function AuthGuard() {
  const intl = useIntl();
  const location = useLocation();
  const currentUser = useAuthStore((state) => state.currentUser);
  const status = useAuthStore((state) => state.status);
  const error = useAuthStore((state) => state.error);
  const initialize = useAuthStore((state) => state.initialize);

  if (status === 'initializing') {
    // Authentication and route loading share the outer Suspense placeholder.
    throw initialize();
  }

  if (status === 'error') {
    return (
      <Result
        status="error"
        title={intl.formatMessage({ id: 'app.request.errorTitle' })}
        subTitle={getRequestErrorMessage(error, intl)}
        extra={
          <Button type="primary" onClick={() => void initialize()}>
            {intl.formatMessage({ id: 'app.error.retry' })}
          </Button>
        }
      />
    );
  }

  if (!currentUser) {
    const redirect = encodeURIComponent(
      `${location.pathname}${location.search}${location.hash}`,
    );
    return <Navigate replace to={`/user/login?redirect=${redirect}`} />;
  }

  return <Outlet />;
}
